import styled from "styled-components";

export const FilterItemBox = styled.div<{disabled: boolean}>`
  display: flex;
  align-items: center;
  padding: 1.5rem;
  cursor: ${props => props.disabled ? "auto" : "pointer"};
`